var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form',[_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"Select groups","label-for":"wp_adminurl"}},[_c('v-select',{attrs:{"id":"time_zone","options":_vm.groups,"multiple":"","value":_vm.selectedGroups,"on-change":_vm.updateGroups}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88ea8e94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/AssignGroups.vue
// module id = null
// module chunks = 